import { useThemeContext, type ThemeContextValue } from '@/lib/theme/theme-provider';

/**
 * Current visual theme (Teams driven, with a browser fallback).
 * See `src/lib/theme/theme-provider.tsx` for the resolution rules.
 */
export function useTheme(): ThemeContextValue {
  return useThemeContext();
}

export type { ThemeContextValue };
